import { CloneDocumentRequest } from '../types/clone-document-request';

/** Builds the `documents/clone` body from the backend's tri-state `itemIds`
    (ClickUp 869eyh3xj): an omitted list clones every position — the key has to
    stay OUT of the payload for that — an empty list copies the Kopfdaten alone,
    a list takes exactly those positions with their whole subtree. */
export function cloneDocumentRequest(
  sourceId: string,
  itemIds: string[] | null | undefined,
  action: CloneDocumentRequest['action'] = 'copy'
): CloneDocumentRequest {
  return itemIds == null ? { action, sourceId } : { action, sourceId, itemIds };
}
